import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { FormControl, FormLabel, FormMessage } from '../form';
import { Checkbox } from '../checkbox';
import { cn } from 'lib/utils';

type CheckboxGsProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> & {
  label?: string;
};

const CheckboxGS = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxGsProps
>(({ className, label, ...props }, ref) => (
  <>
    <FormControl>
      <Checkbox ref={ref} {...props} className={cn(className)} />
    </FormControl>
    {label && <FormLabel>{label}</FormLabel>}
    <FormMessage />
  </>
));
CheckboxGS.displayName = 'CheckboxGS';

export { CheckboxGS };
